import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ContentZoom from 'react-content-zoom';
import notImage from 'images/foto_en_preparacion.png';
import style from './style.scss'; //NOSONAR
import Loader from "components/Loader";

const Gallery = (props) => {
    const images = props.images;
    const [image, setImage] = useState(images ? images[0].imageUrl : notImage);
    const [loading, setLoading] = useState(false);

    const getThumb = (item, itemSize) => {
        const size = itemSize;
                
        return item ? item.imageTag.replace("#width#", size).replace("#height#", size).replace('"#width#"', size).replace('"#height#"', size).replace("~", item.imageUrl.split('/arquivos')[0]) : null;
    }

    const resizeImage = (imageUrl, size) => {
        const num = (imageUrl.substring(imageUrl.indexOf("/ids/")+5, imageUrl.indexOf("/ids/")+11)*1);

        if(!(num && typeof num === 'number')) return false;

        let cod = imageUrl.substring(imageUrl.indexOf("/ids/")+5, imageUrl.indexOf("/ids/")+11);
        imageUrl = imageUrl.replace(cod, cod+'-'+size+'-'+size);
        
        return imageUrl;
    }

    const applyImage = (image) => {
        setImage(image);
        setLoading(true);
        setTimeout(() => {
            setLoading(false)
        },1);
    }


    return (
        <div className="product-image">
            <div className="product-image-content"> 
                {!loading && <ContentZoom zoomPercent={180}
                    largeImageUrl={resizeImage(image, 1000)}
                    imageUrl={resizeImage(image, 750)}              
                />} 
                {loading &&
                    <div className="product-image-loader"> <Loader/></div>
                }                       
            </div>
            {images.length > 1 && <div className="product-image-thumbs">
                <ul className='product-image-thumbs-list'>
                    {images.slice(0,6).map( (item, i) =>
                        <li className={'product-image-thumbs-item' + (item.imageUrl === image ? ' active ' : '')} onClick={()=>applyImage(item.imageUrl)} key={i} dangerouslySetInnerHTML={{__html: getThumb(item, 100)}} />
                    )}  
                </ul>
            </div>}
        </div>
    )
}

Gallery.propTypes = {
    images: PropTypes.array,
    flags: PropTypes.node
}
export default Gallery;
